export default __webpack_public_path__ + "static/media/avlare_gaiter.b223463c.jpg";